<template>
  <section class="pictures" id="pictures">
    <div class="container-fluid">
      <div class="img-wrapper fade-in">
        <div class="img">
          <img src="../../../assets/images/gallery/gal-1.jpg" alt="Frau mit roten Haaren">
        </div>
        <div class="img">
          <img src="../../../assets/images/gallery/gal-2.jpg" alt="Mann mit Tattoo und Style">
        </div>
        <div class="img">
          <img src="../../../assets/images/gallery/gal-5.jpg" alt="Frau mit Kurzhaarschnitt">
        </div>
        <div class="img">
          <img src="../../../assets/images/gallery/gal-4.jpg" alt="Mann vom Seitenprofil mit dunklen Haaren">
        </div>
        <div class="img">
          <img src="../../../assets/images/gallery/gal-3.jpg" alt="Frau mit Afrohaaren">
        </div>
        <div class="img">
          <img src="../../../assets/images/gallery/gal-6.jpg" alt="Mann vom Seitenrofil und hellen Haaren">
        </div>
        <div class="img">
          <img src="../../../assets/images/gallery/gal-7.jpg" alt="Frau mit braunen langen Haaren">
        </div>
        <div class="img">
          <img src="../../../assets/images/gallery/gal-8.jpg" alt="Mann mit Sonnenbrille und Undercut">
        </div>
        <div class="img">
          <img src="../../../assets/images/gallery/gal-9.jpg" alt="Frau mit langen Haaren und Mittelscheitel">
        </div>
        <div class="img">
          <img src="../../../assets/images/gallery/gal-11.jpg" alt="Mann mit schulterlangen blonden und welligen Haaren">
        </div>
        <div class="img">
          <img src="../../../assets/images/gallery/gal-10.jpg" alt="Frau mit platinfarbiges Haar">
        </div>
        <div class="img">
          <img src="../../../assets/images/gallery/gal-14.jpg" alt="Zwei Männer mit Rasterlocken">
        </div>
        <div class="img">
          <img src="../../../assets/images/gallery/gal-13.jpg" alt="Frau vom Seitenprofil mit langem blonden Haar">
        </div>
        <div class="img">
          <img src="../../../assets/images/gallery/gal-12.jpg" alt="Frau vom Seitenprofil mit einem Kurzhaarschnitt">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Pictures",
  mounted() {
    //var outer = document.querySelector('.img-wrapper').offsetWidth;
    //var inner = document.querySelector('.img').offsetWidth;
    //document.querySelector('.img-wrapper').scrollLeft(outer);
  }
}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';

.pictures {
  .container-fluid {
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
    overflow-x: auto;
    white-space: nowrap;
  }

  .img-wrapper {
    position: relative;
    display: block;

    .img {
      position: relative;
      display: inline-block;
      margin: 0;

      img {
        height: 370px;
        filter: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#grayscale"); /* Firefox 3.5+ */
        -webkit-filter: grayscale(70%); /* Chrome 19+ & Safari 6+ */
        @include transition;

        @include media-breakpoint-down(md) {
          height: 280px;
        }

        @include media-breakpoint-down(sm) {
          height: 200px;
        }

        @include media-breakpoint-down(xs) {
          height: 150px;
        }

        &:hover {
          filter: none;
          -webkit-filter: grayscale(0%);
        }

      }
    }
  }

  // Hide scrollbar
  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }
}
</style>
